export { default } from './useReportsAmplitude';
